"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnackbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _notistack = require("notistack");
var _faCheck = require("@fortawesome/free-solid-svg-icons/faCheck");
var _faInfo = require("@fortawesome/free-solid-svg-icons/faInfo");
var _Snackbar = require("./Snackbar");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var snackbarDefaultTitle = {
  "default": '',
  info: 'Info',
  warning: 'Warning',
  success: '',
  error: 'Error'
};
var snackbarDefaultIcon = {
  "default": _faInfo.faInfo,
  info: _faInfo.faInfo,
  warning: _faInfo.faInfo,
  success: _faCheck.faCheck,
  error: _faInfo.faInfo
};
var useSnackbar = function useSnackbar() {
  var _originUseSnackbar = (0, _notistack.useSnackbar)(),
    originalEnqueueSnackbar = _originUseSnackbar.enqueueSnackbar,
    closeSnackbar = _originUseSnackbar.closeSnackbar;
  var content = (0, _react.useCallback)(function (_ref) {
    var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      icon = _ref.icon,
      title = _ref.title;
    return function (key, message) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Snackbar.Snackbar, {
        icon: icon || snackbarDefaultIcon[variant],
        keyId: key,
        message: message,
        title: title || snackbarDefaultTitle[variant],
        type: variant,
        closeSnackbar: closeSnackbar
      }));
    };
  }, [closeSnackbar]);
  var enqueueSnackbar = (0, _react.useCallback)(function (message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    originalEnqueueSnackbar(message, _objectSpread({
      autoHideDuration: 2000,
      content: content(options),
      anchorOrigin: {
        horizontal: 'right',
        vertical: 'top'
      }
    }, options));
  }, [originalEnqueueSnackbar, content]);
  return {
    enqueueSnackbar: enqueueSnackbar,
    closeSnackbar: closeSnackbar
  };
};
exports.useSnackbar = useSnackbar;